/**
 * Returns the singular or plural form of a word based on the count
 * @param count - The number to check for pluralization
 * @param singular - The singular form of the word
 * @param plural - The plural form of the word
 * @returns The appropriate form based on the count
 */
export const pluralize = (
  count: number,
  singular: string,
  plural: string,
): string => (count === 1 ? singular : plural);

// Formats a game genre label, uppercasing known acronyms and title-casing others.
export const formatGenreLabel = (input: string): string => {
  const normalized = input.trim().toLowerCase().replace(/_/g, " ");

  const genreMap: Record<string, string> = {
    action: "Action",
    adventure: "Adventure",
    fighting: "Fighting",
    platformer: "Platformer",
    puzzle: "Puzzle",
    "role playing game": "Role Playing Game",
    rpg: "RPG",
    simulation: "Simulation",
    sports: "Sports",
    strategy: "Strategy",
  };

  // Check if we have a direct mapping
  if (genreMap[normalized]) {
    return genreMap[normalized];
  }

  const acronyms = new Set(["rpg", "fps", "mmo", "moba", "ugc", "mmorpg"]);
  if (acronyms.has(normalized)) return normalized.toUpperCase();

  //"role playing game" -> "Role Playing Game"
  return normalized
    .split(" ")
    .filter((part) => part.length > 0)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};
